import React from "react";
import LoginPage from "src/components/auth/login/loginWithEmail";
import MetaDecorator from "src/_common/hooks/custom/MetaDecorator";

export default function LoginWithEmailContainer() {
  return (
    <React.Fragment>
      <MetaDecorator
        title="Employer Login | Dr.Job AI Recruitment Platform"
        description="Access your Dr.Job employer dashboard to manage job postings, screen candidates, and automate hiring with AI-powered recruitment tools."
        keywords="employer login, Dr.Job employer, recruitment dashboard"
        canonical="https://employer.drjobpro.com/"
        robots="index, follow"
        hreflang="en"
      />
      <LoginPage />
    </React.Fragment>
  );
}
